//#region [IMPORT]

// === THIRD-PARTY ===
import React, {  } from 'react';

// === COMPONENTS ===
import { FileProvider } from '../FileContext/FileContext';
import { LayoutProvider } from '../Panel/PanelContext';
import { DropProvider } from 'components/DragDrop/DropContext';
import { Panel } from '../Panel';
import Styled from 'components/Styled/Styled';

//#endregion

//-----------------------------------------------------------------
export function FileView() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled>
        <FileProvider>
          <LayoutProvider name='file-viewer-layout' >
            <DropProvider>
              <Panel id={1} />
            </DropProvider>
          </LayoutProvider>
        </FileProvider>
      </Styled>
    )
  }

  //#endregion

  return display();
}